export default "__VITE_ASSET__nfSYHBnrEfg1A82Bgp7Mrg__";